import styled from 'styled-components';

export const MainViewS = styled.div`
	min-height: 100vh;
	width: 100%;
	display: flex;
	flex-direction: column;
	overflow: hidden;
`;
